import { IContractIngestionRequest, StartOrchestratorResponse } from '../../definitions/ContractIngestionRequest'
import ApiUrlCompiler from '../api_urls/ApiUrlCompiler'
import API_URLS from '../ApiUrls'
import HttpClient from '../HttpClient'

class ContractIngestionApiClientClass {
    getExecutionResult = async (executionArn: string): Promise<any> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.contractIngestion.getExecutionResult)
        const body = { executionArn }

        return await HttpClient.post<any>(url, body, headers)
    }

    startOrchestrator = async (payload: IContractIngestionRequest): Promise<StartOrchestratorResponse> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.contractIngestion.startOrchestrator)
        const body = payload
        return await HttpClient.post<StartOrchestratorResponse>(url, body, headers)
    }
}

const ContractIngestionApiClient = new ContractIngestionApiClientClass()
export default ContractIngestionApiClient
